import { Link } from "react-router-dom";
import { ShieldCheck, Sparkles, Lock, HeartHandshake } from "lucide-react";

const LOGO = "/manajodi-logo.png";
const HERO = "https://images.unsplash.com/photo-1722952934708-749c22eb2e58?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export function BrandIcon({ className = "h-16 w-16" }) {
  return (
    <img
      src={LOGO}
      alt="ManaJodi logo"
      className={`${className} object-contain rounded-2xl shadow-[0_10px_34px_rgba(59,10,18,0.25)] ring-1 ring-[#C59B27]/30`}
      draggable="false"
      width="512"
      height="512"
    />
  );
}

const CHIPS = [
  { icon: ShieldCheck, label: "Verified Profiles" },
  { icon: Sparkles, label: "Smart Matching" },
  { icon: Lock, label: "Safe & Private" },
  { icon: HeartHandshake, label: "Meaningful Connections" },
];

export function AuthShell({ children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFBF7]" data-testid="auth-shell">
      {/* Hero (desktop) */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden text-[#FAF5F0]">
        <img src={HERO} alt="A couple celebrating their wedding" className="absolute inset-0 w-full h-full object-cover" draggable="false" />
        <div aria-hidden className="absolute inset-0 bg-gradient-to-br from-[#3B0A12]/95 via-[#58111A]/80 to-[#781826]/70" />
        <div aria-hidden className="absolute -bottom-24 -left-16 w-80 h-80 rounded-full bg-[#C59B27]/20 blur-3xl" />

        <div className="relative z-10 flex items-center gap-3">
          <BrandIcon className="h-12 w-12" />
          <span className="font-serif font-bold text-2xl tracking-tight">Mana<span className="text-[#E2C382]">Jodi</span></span>
        </div>

        <div className="relative z-10 max-w-md">
          <div className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#E2C382] mb-5">
            <span className="h-px w-8 bg-[#C59B27]/70" /> Your Jodi. Your Journey.
          </div>
          <h2 className="font-serif text-4xl xl:text-5xl font-bold leading-[1.08]">Find Your<br />Life Partner</h2>
          <p className="text-[#F0D9DD] mt-4 text-[15px] leading-relaxed">Meaningful connections for a brighter tomorrow.</p>
          <div className="mt-8 grid grid-cols-2 gap-3 max-w-sm">
            {CHIPS.map(({ icon: Icon, label }) => (
              <span key={label} className="flex items-center gap-2 text-sm text-[#F6E7E9] bg-white/10 border border-white/15 rounded-xl px-3 py-2 backdrop-blur-sm">
                <Icon className="w-4 h-4 text-[#E2C382] shrink-0" /> {label}
              </span>
            ))}
          </div>
        </div>

        <p className="relative z-10 text-xs text-[#E7CDCF]">Powered by Vijay Software Solutions Pvt Ltd</p>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center px-5 py-10 sm:px-10">
        <div className="w-full max-w-md">{children}</div>
      </div>

      <Link to="/admin/login" data-testid="secure-access-link" aria-label="Secure Access"
        className="fixed bottom-3 right-4 text-[10px] text-[#C9BCA8] hover:text-[#9E7B1B] transition-colors">Secure Access</Link>
    </div>
  );
}

export function AuthCard({ children }) {
  return (
    <div className="bg-white rounded-3xl border border-[#EBD9AE] shadow-[0_18px_50px_-12px_rgba(59,10,18,0.18)] p-7 sm:p-9" data-testid="auth-card">
      {children}
    </div>
  );
}
